import { z } from 'zod';

// Enums shared between apps/api and the frontend. Kept in sync with
// packages/db-supabase/src/schema/enums.ts (they're the source of truth at
// the DB layer; we duplicate here so the wire format doesn't depend on the
// DB package).

export const OPPORTUNITY_STATES = [
  'detected',
  'active',
  'weakened',
  'reappeared',
  'closed',
  'expired',
  'executed',
  'passed',
  'snoozed',
] as const;
export const OpportunityStateSchema = z.enum(OPPORTUNITY_STATES);
export type OpportunityState = z.infer<typeof OpportunityStateSchema>;

export const MARKET_KINDS = ['h2h', 'handicap', 'totals', 'set_winner'] as const;
export const MarketSchema = z.enum(MARKET_KINDS);
export type Market = z.infer<typeof MarketSchema>;

export const OPERATOR_ROLES = ['admin', 'senior', 'junior'] as const;
export const OperatorRoleSchema = z.enum(OPERATOR_ROLES);

export const SIGNAL_MANUAL_SOURCES = ['winnerodds', 'manual', 'other'] as const;
export const SignalManualSourceSchema = z.enum(SIGNAL_MANUAL_SOURCES);
export type SignalManualSource = z.infer<typeof SignalManualSourceSchema>;
